/**
 * Получение куки
 * @param {string} name Название куки
 * @returns {*} Значение куки
 */
export function getCookie (name) {
  let matches = document.cookie.match(new RegExp(
    '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
  ))
  let value
  if (matches) {
    value = decodeURIComponent(matches[1])
    try {
      value = JSON.parse(value)
    } catch (e) {
    }
  }
  return value
}
/**
 * Установка куки
 * @param {string} name       Название куки
 * @param {string} value      Значение
 * @param {*} options         Опции
 * @param {*} options.expires Время жизни куки
 */
export function setCookie (name, value, options = {}) {
  let expires = options.expires

  if (typeof expires === 'number' && expires) {
    let d = new Date()
    d.setTime(d.getTime() + expires * 1000)
    expires = options.expires = d
  }
  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString()
  }
  if (Array.isArray(value)) {
    value = JSON.stringify(value)
  }

  value = encodeURIComponent(value)

  let updatedCookie = name + '=' + value

  for (let propName in options) {
    if (options.hasOwnProperty(propName)) {
      updatedCookie += '; ' + propName
      let propValue = options[propName]
      if (propValue !== true) {
        updatedCookie += '=' + propValue
      }
    }
  }

  document.cookie = updatedCookie
}
/**
 * Удаление куки
 * @param {string} name       Название куки
 * @param {*} options         Опции
 */
export function removeCookie (name, options = {}) {
  options = { ...options, expires: -1 }
  setCookie(name, '', options)
}
